<template>
  <div class="pt-5 container-padding">
    <slot />
  </div>
</template>
